import { useMutation, queryCache } from 'react-query';
import axios from 'axios';
import useStore from 'zstore';
import { useCurrentUser } from 'hooks/useCurrentUser';

interface DeleteApiUserParams {
  id: number;
}

const deleteApiUser = async ({ id }: DeleteApiUserParams): Promise<void> => {
  await axios.delete(`/api/v4/api_users/${id}`);
};

export const useDeleteApiUser = () => {
  const { makeToast } = useStore();
  const user = useCurrentUser();

  return useMutation(deleteApiUser, {
    onSuccess: () => {
      makeToast({ text: 'API key deleted successfully.', isError: false });
    },
    onError: (error: any) => {
      console.error('Error deleting API user:', error);
      const errorMessage = error.response?.data?.message || 'Error deleting API key. Please try again.';
      makeToast({ text: errorMessage, isError: true });
    },
    onSettled: () => {
      queryCache.invalidateQueries(['apiUsers', user?.primaryPartner.id]);
    },
  });
};